module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ts-section"
  }, [_c('div', {
    staticClass: "ts-section-header onepx-b"
  }, [(!_vm.$slots.title) ? _c('p', {
    staticClass: "ts-section-header--title"
  }, [(!_vm.pageTitle) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$route.name)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.pageTitle))])]) : _c('p', {
    staticClass: "ts-section-header--title"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "ts-section-header--menu"
  }, [_vm._t("menu")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ts-section-content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "ts-section-footer"
  }, [_vm._t("footer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4df53b6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsSection.vue
// module id = 828
// module chunks = 39